import Vue from 'vue';
export default Vue.extend({
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: true,
        },
        value: {
            type: String,
            required: false,
            default: '',
        },
    },
    methods: {
        copyClicked() {
            // navigator not working on non secure
            navigator.clipboard.writeText(this.value);
        },
    },
});
